import { SET_FEATURE_ACCESS } from 'redux/actionTypes';

const initialState = {
	onboardingEnabled: true,
	billPaymentEnabled: true,
	ccbpEnabled: true,
	tokenizationEnabled: true,
	juspayTokenizationEnabled: true,
	loadPayEnabled: false,
};

const FeatureAccessReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_FEATURE_ACCESS:
			return {
				...state,
				...action.payload,
			};

		default:
			return state;
	}
};

export default FeatureAccessReducer;
